export enum STATIC_DATA_TYPE {
  PAYOFFS = 'payoffs',
  CAPITAL_PROTECTION = 'capitalProtection',
  UKSPA_CODES = 'ukspaCodes',
  UNDERLYINGS = 'underlyings',
  ISSUERS = 'issuers',
  CREDIT_RATING_DESCRIPTIONS = 'creditRatingDescriptions',
  CREDIT_RATING_OUTLOOKS = 'creditRatingOutlooks',
  DEFAULT_RISK_DESCRIPTIONS = 'defaultRiskDescriptions',
  TRADING_CALENDARS = 'tradingCalendars',
  SETTLEMENT_CALENDARS = 'settlementCalendars',
  TARGET_MARKETS = 'targetMarkets',
  REFERENCE_ENTITY = 'referenceEntity',
  REFERENCE_OBLIGATION = 'referenceObligation',
  AGENTS = 'agents',
  ISSUERS_ENTITY = 'issuersEntity',
  LEGAL_PROGRAMMES = 'legalProgrammes',
  LISTING_VENUES = 'listingVenues',
  CURRENCIES = 'currencies',
  PHYSICAL_SETTLEMENT_MATRIX = 'physicalSettlementMatrix',
  UNDERLYING_ASSETS = 'underlyingAssets',
  EXCHANGES = 'exchanges',
  DATA_INGESTION_CONFIG = 'dataIngestionConfig',
  DATA_EXPORT_FORMATS = 'dataExportFormats',
  DESKS = 'desks',
  CONTACTS = 'contacts',
  HURDLES_AND_SPREADS = 'hurdlesAndSpreads',
}
